"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPendingPaymentURLByOrderNumberApi = exports.pickupOrderApi = exports.searchOrderWithClientApi = exports.getOrderWithClientApi = exports.getFilteredOrdersApi = exports.getOrderByPaymentNumberApi = exports.verifyOrderPaymentApi = exports.cancelOrderByIdApi = exports.getOrderByNumberApi = exports.getOrderByClientApi = exports.newOrderApi = void 0;
const apiPath_1 = require("../apiPath");
const newOrderApi = async (axiosInstance, form) => {
    try {
        const _data = await axiosInstance.post(apiPath_1.API_PATH.order.newOrder.frontend, form);
        return _data.data;
    }
    catch (error) {
        throw error.response?.data || error.message;
    }
};
exports.newOrderApi = newOrderApi;
const getOrderByClientApi = async (axiosInstance, filter) => {
    try {
        const _data = await axiosInstance.get(apiPath_1.API_PATH.order.getOrdersByClient.frontend, {
            params: {
                ...filter,
            },
        });
        return _data.data;
    }
    catch (error) {
        throw error.response?.data || error.message;
    }
};
exports.getOrderByClientApi = getOrderByClientApi;
const getOrderByNumberApi = async (axiosInstance, orderNumber) => {
    try {
        const _data = await axiosInstance.get(apiPath_1.API_PATH.order.getOrderByNumber(orderNumber).frontend);
        return _data.data;
    }
    catch (error) {
        throw error.response?.data || error.message;
    }
};
exports.getOrderByNumberApi = getOrderByNumberApi;
const cancelOrderByIdApi = async (axiosInstance, orderId) => {
    try {
        const _data = await axiosInstance.get(`/order/cancel/${orderId}`);
        return _data.data;
    }
    catch (error) {
        throw error.response?.data || error.message;
    }
};
exports.cancelOrderByIdApi = cancelOrderByIdApi;
// export const confirmOrderPaymentApi = async (
//   axiosInstance: AxiosInstance,
//   orderId: string
// ) => {
//   try {
//     const _data = await axiosInstance.get<Order>(
//       `/order/confirm_payment/${orderId}`
//     );
//     return _data.data;
//   } catch (error: any) {
//     throw error.response?.data || error.message;
//   }
//  };
const verifyOrderPaymentApi = async (axiosInstance, orderNumber) => {
    try {
        const _data = await axiosInstance.get(apiPath_1.API_PATH.order.verifyOrderPayment(orderNumber).frontend);
        return _data.data;
    }
    catch (error) {
        throw error.response?.data || error.message;
    }
};
exports.verifyOrderPaymentApi = verifyOrderPaymentApi;
const getOrderByPaymentNumberApi = async (axiosInstance, paymentNumber) => {
    try {
        const _data = await axiosInstance.get(`/order/payment_number/` + paymentNumber);
        return _data.data;
    }
    catch (error) {
        throw error.response?.data || error.message;
    }
};
exports.getOrderByPaymentNumberApi = getOrderByPaymentNumberApi;
const getFilteredOrdersApi = async (axiosInstance, filter) => {
    try {
        const _data = await axiosInstance.get(apiPath_1.API_PATH.order.filterOrders.frontend, { params: filter });
        return _data.data;
    }
    catch (error) {
        throw error.response?.data || error.message;
    }
};
exports.getFilteredOrdersApi = getFilteredOrdersApi;
const getOrderWithClientApi = async (axiosInstance, orderNumber) => {
    try {
        const _data = await axiosInstance.get(apiPath_1.API_PATH.order.orderWithClient(orderNumber).frontend);
        return _data.data;
    }
    catch (error) {
        throw error.response?.data || error.message;
    }
};
exports.getOrderWithClientApi = getOrderWithClientApi;
const searchOrderWithClientApi = async (axiosInstance, orderNumber) => {
    try {
        const _data = await axiosInstance.get(apiPath_1.API_PATH.order.orderWithClient(orderNumber).frontend);
        return _data.data;
    }
    catch (error) {
        throw error.response?.data || error.message;
    }
};
exports.searchOrderWithClientApi = searchOrderWithClientApi;
const pickupOrderApi = async (axiosInstance, pickupCode) => {
    try {
        const _data = await axiosInstance.get(apiPath_1.API_PATH.order.pickupOrder(pickupCode).frontend);
        return _data.data;
    }
    catch (error) {
        throw error.response?.data || error.message;
    }
};
exports.pickupOrderApi = pickupOrderApi;
const getPendingPaymentURLByOrderNumberApi = async (axiosInstance, paymentNumber) => {
    try {
        const _data = await axiosInstance.get(apiPath_1.API_PATH.order.getPendingPaymentUrl(paymentNumber).frontend);
        return _data.data;
    }
    catch (error) {
        throw error.response?.data || error.message;
    }
};
exports.getPendingPaymentURLByOrderNumberApi = getPendingPaymentURLByOrderNumberApi;
//# sourceMappingURL=order.js.map